/**
 * @module events/types/dragEnd
 */

/**
 * @type {string}
 */
export default 'dragend'
